import { IsoCountryCode } from './IsoCountryCodes'

export enum AiUserPersonaTrait {
  MUSIC_PRODUCER = 'music producer',
  SONGWRITER = 'songwriter',
  VOCALIST = 'vocalist',
  VIDEO_CREATOR = 'video creator',
  OTHER = 'other',
  /**
   * @deprecated
   */
  MUSIC = 'music',
  /**
   * @deprecated
   */
  CREATOR = 'creator',
  /**
   * @deprecated
   */
  CONTENTPRO = 'contentpro',
  /**
   * @deprecated
   */
  DEVELOPER = 'developer',
  /**
   * @deprecated
   */
  PRODUCER = 'producer',
  /**
   * @deprecated
   */
  INDUSTRYPRO = 'industrypro'
}

export enum AiUserIntentTrait {
  CREATE_SONGS_IN_MY_OWN_VOICE = 'own_voice',
  CREATE_SONGS_IN_ANOTHER_ARTISTS_VOICE = 'other_voice',
  SPLIT_SONGS_INTO_STEMS = 'stem_split',
  MASTER_A_SONG = 'mastering',
  IMPROVE_MY_SINGING_ABILITY = 'improve_singing',
  CREATE_VIDEO_VOICEOVERS = 'video_voiceover',
  IMPROVE_VOCAL_QUALITY_OF_A_SONG = 'vocal_quality',
  OTHER = 'other'
}

export enum AIUserSourceTrait {
  GOOGLE = 'google',
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
  INSTAGRAM = 'instagram',
  X = 'x',
  REDDIT = 'reddit',
  FRIEND = 'friend',
  /**
   * @deprecated
   */
  OTHER = 'other'
}

export enum AIUserStartupFeatureTrait {
  VOICE_CREATION = 'voices',
  VOICE_CONVERSION = 'convert',
  AUDIO_EDITING = 'vocal-remover'
}

export enum AiUserMusicYearsTrait {
  ONE = '<1',
  TWO = '1-2',
  FOUR = '3-4',
  FIVE = '5+',
  /**
   * @deprecated
   */
  TWO_FIVE = '2-5'
}

/**
 * @deprecated
 */
export enum AiUserProblemTrait {
  CREATE_AI_VOICES = 'create ai voices',
  API = 'api',
  VOICE_LIBRARY = 'voice library',
  TOOLS = 'tools',
  AI_COVER = 'ai cover',
  EARN = 'earn'
}

export enum AiUserDowngradeReason {
  WORK = 'I couldn’t get it to work',
  BETTER = 'I found a better platform',
  EXPENSIVE = 'It is too expensive',
  FINISHED = 'The project I was working on is finished',
  FREE = 'The free tier is good enough for my needs',
  MISSING_FEATURES = 'It was missing features I needed',
  OTHER = 'Other'
}

export enum AIUserUseTrait {
  PROFESSIONAL = 'professional',
  HOBBY = 'hobby',
  FUN = 'fun',
  /**
   * @deprecated
   */
  WORK = 'work',
  /**
   * @deprecated
   */
  EDUCATION = 'education',
  /**
   * @deprecated
   */
  PERSONAL = 'personal'
}

export enum CSATValue {
  VERY_SATISFIED = 'Very satisfied',
  SATISFIED = 'Satisfied',
  INDIFERENT = 'Indifferent',
  UNSATISFIED = 'Unsatisfied',
  VERY_UNSATISFIED = 'Very unsatisfied'
}

export type CSATScore = {
  score: CSATValue
  submittedAt: string
}

/**
 * @deprecated
 */
export interface AiUserTraits524 {
  ob_persona?: AiUserPersonaTrait
  ob_years?: AiUserMusicYearsTrait
  ob_use?: AIUserUseTrait
  ob_problem?: AiUserProblemTrait
  ob_source?: AIUserSourceTrait
  ob_persona_other?: string
  ob_role?: string
  /**
   * Used for identifying the version of the onboarding survey user filled out
   */
  ob_version?: string
  email?: boolean
}

/**
 * Onboarding survey traits
 */
export interface AiUserTraits1024 {
  ob_persona?: AiUserPersonaTrait
  ob_persona_other?: string

  ob_use?: AIUserUseTrait

  ob_income?: boolean

  ob_daw?: boolean

  ob_years?: AiUserMusicYearsTrait

  ob_source?: AIUserSourceTrait

  ob_startup_feature?: AIUserStartupFeatureTrait

  ob_tutorial?: 'yes' | 'no'

  ob_country?: IsoCountryCode

  ob_jtbd?: AiUserIntentTrait
  ob_jtbd_other?: string

  /**
   * Used for identifying the version of the onboarding survey user filled out
   */
  ob_version?: string
  email?: boolean

  /**
   * Whether the user has completed the tutorial
   */
  passed_tutorial?: boolean
}

export interface AiUserTraits extends AiUserTraits1024 {
  /** downgrade feedback */
  downgradeFeedback?: string
  downgradeReason?: AiUserDowngradeReason

  /** Sourcebuster attribution */
  type?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  ep?: string
  rf?: string

  source?: AIUserSourceTrait
  /** @deprecated */
  persona?: string
  /** @deprecated */
  musicYears?: string
  /** @deprecated */
  musicProblem?: string
  /** @deprecated */
  goal?: string

  /**
   * Used for identifying whether user has filled out the voice designer modal
   */
  voiceDesignerModalDismissed?: boolean

  csatSubmittedAt?: string

  /**
   * Whether the user has completed the studio tour
   */
  studioTourCompleted?: boolean
}
